import { render } from "./AuthenticatedShell.vue?vue&type=template&id=b2c558da"
import script from "./AuthenticatedShell.vue?vue&type=script&lang=js"
export * from "./AuthenticatedShell.vue?vue&type=script&lang=js"

import "./AuthenticatedShell.vue?vue&type=style&index=0&id=b2c558da&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__